/* PB Pop Stars — de bolletjes onder de productslider.

   De slider zelf is CSS: een rij met scroll-snap, waar de browser het vegen,
   de vaart en het terugveren van doet. Dit script doet twee dingen eromheen:
   het zet het bolletje van de foto die in beeld staat aan, en het laat een
   klik op een bolletje naar die foto schuiven.

   Zonder JS blijft de slider gewoon werken — je veegt hem met de hand en het
   eerste bolletje blijft aan. De knoppen zijn dan het enige dat niets doet, en
   die staan er alleen als er iets te wisselen valt.

   En één ding op desktop. Boven het breekpunt (data-pbps-break op de slider,
   dezelfde instelling als de stylesheet pb-pop-stars-desktop.css) staan de
   producten naast elkaar en valt er niets te vegen. Dan kloppen twee dingen
   niet meer: de baan houdt een tabindex omdat een scrollbare doos anders niet
   met het toetsenbord te bereiken is, en de sectie meldt zich als carrousel —
   een tabstop die niets doet, en een aankondiging van een carrousel die er geen
   is. Dit script zet ze weg en zet ze terug zodra het venster smaller wordt.
   (Tot 8 september 2026 deed pb-liquids-desk.js dat, maar dat script is er
   alleen op de pre-sale pagina.) */
(function () {
  if (window.PBPopStars) {
    window.PBPopStars.init(document);
    return;
  }

  var controllers = new WeakMap();

  function findSliders(root) {
    var sliders = [];

    if (root.matches && root.matches('[data-pbps-slider]')) sliders.push(root);
    if (root.querySelectorAll) {
      sliders = sliders.concat(Array.prototype.slice.call(root.querySelectorAll('[data-pbps-slider]')));
    }

    return sliders;
  }

  /* De carrousel-semantiek aan (telefoon) of uit (desktop). De waarden die
     teruggezet worden staan letterlijk zo in sections/pb-pop-stars.liquid. */
  function flatten(slider, track, slides, flat) {
    if (flat) {
      track.setAttribute('tabindex', '-1');
      slider.removeAttribute('aria-roledescription');
      slides.forEach(function (slide) {
        slide.removeAttribute('aria-roledescription');
        slide.removeAttribute('aria-label');
      });
      return;
    }

    track.setAttribute('tabindex', '0');
    slider.setAttribute('aria-roledescription', 'carrousel');
    slides.forEach(function (slide, index) {
      slide.setAttribute('aria-roledescription', 'dia');
      slide.setAttribute('aria-label', index + 1 + ' van ' + slides.length);
    });
  }

  function createController(slider) {
    var track = slider.querySelector('[data-pbps-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-pbps-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-pbps-dot]'));
    if (!track) return null;

    /* Het breekpunt, als de sectie er een meegeeft. Zonder (of zonder
       matchMedia) blijft de baan altijd een carrousel, zoals voorheen. */
    var breakpoint = parseInt(slider.getAttribute('data-pbps-break'), 10);
    var query = null;
    if (breakpoint && window.matchMedia) {
      query = window.matchMedia('(min-width: ' + breakpoint + 'px)');
    }

    function onWidth() {
      flatten(slider, track, slides, query.matches);
    }

    if (query) {
      if (query.addEventListener) {
        query.addEventListener('change', onWidth);
      } else if (query.addListener) {
        query.addListener(onWidth);
      }
      onWidth();
    }

    function unwatch() {
      if (!query) return;
      if (query.removeEventListener) {
        query.removeEventListener('change', onWidth);
      } else if (query.removeListener) {
        query.removeListener(onWidth);
      }
      flatten(slider, track, slides, false);
    }

    /* De bolletjes zijn er alleen als er iets te wisselen valt; zonder blijft
       er van de controller alleen het breekpunt over. */
    if (slides.length < 2 || dots.length !== slides.length) {
      return {
        destroy: function () {
          unwatch();
          controllers.delete(slider);
        },
        selectSlide: function () {},
      };
    }

    var current = -1;

    function mark(index) {
      if (index === current || index < 0 || index >= dots.length) return;
      current = index;

      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    /* Welke foto in beeld staat, gemeten aan het midden van de baan: de foto
       waarvan het midden daar het dichtst bij ligt. Dat klopt ook halverwege
       een veeg en tijdens het terugveren, waar een drempel van "meer dan de
       helft zichtbaar" tussen twee foto's in even niets aanwijst. */
    function readPosition() {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var nearest = 0;
      var shortest = Infinity;

      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        if (distance < shortest) {
          shortest = distance;
          nearest = i;
        }
      });

      mark(nearest);
    }

    /* Een scroll vuurt tientallen keren per veeg; de bolletjes hoeven maar een
       keer per frame bij te werken. */
    var frame = 0;
    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        readPosition();
      });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;

      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var left = slide.offsetLeft - track.offsetLeft;

      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: still ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }

      /* Meteen aanzetten in plaats van op de scroll te wachten: het schuiven
         duurt een halve seconde en het bolletje moet direct antwoorden op de
         tik. */
      mark(index);
    }

    function onDotClick(event) {
      goTo(dots.indexOf(event.currentTarget));
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', onDotClick);
    });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    readPosition();

    return {
      destroy: function () {
        dots.forEach(function (dot) {
          dot.removeEventListener('click', onDotClick);
        });
        track.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (frame) window.cancelAnimationFrame(frame);
        unwatch();
        controllers.delete(slider);
      },
      selectSlide: function (slide) {
        var index = slides.indexOf(slide);
        if (index >= 0) goTo(index);
      },
    };
  }

  function init(root) {
    findSliders(root).forEach(function (slider) {
      if (controllers.has(slider)) return;

      var controller = createController(slider);
      if (controller) controllers.set(slider, controller);
    });
  }

  function destroy(root) {
    findSliders(root).forEach(function (slider) {
      var controller = controllers.get(slider);
      if (controller) controller.destroy();
    });
  }

  window.PBPopStars = {
    init: init,
    destroy: destroy,
  };

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  /* In de theme-editor schuift de slider naar het product waarvan je het blok
     aanklikt, zodat je ziet wat je aan het bewerken bent. */
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest ? event.target.closest('[data-pbps-slide]') : null;
    var slider = slide && slide.closest('[data-pbps-slider]');
    var controller = slider && controllers.get(slider);

    if (controller) controller.selectSlide(slide);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
})();
